import HeaderDesk from "./Desk/HeaderDesk";
import HeaderMob from "./Mob/HeaderMob";

export const Header = () => {
  return <>{window.innerWidth <= 768 ? <HeaderMob /> : <HeaderDesk />}</>;
};

export default Header;
